import { CancelAppointment } from "@/store/modules/appointments/interfaces/CancelAppointment";
import { PostAppointmentBody } from "@/store/modules/appointments/interfaces/PostAppointmentBody";

import axios from "./axios";

const create = async (body: PostAppointmentBody) => {
  const { data } = await axios.post("/appointment", body);
  return data;
};

const cancel = async ({ id, cancellationReason }: CancelAppointment) => {
  const { data } = await axios.post(`/appointment/${id}/cancellation`, { cancellationReason });
  return data;
};

const getSummary = async (appointmentId: string) => {
  const { data } = await axios.get(`/appointment/${appointmentId}/summary`);
  return data;
};

export const AppointmentsApi = { create, cancel, getSummary };
